import { CommandRequestType } from "../../authentication/connection/commandRequestType";
import { ICommandParameters } from "../../authentication/connection/iCommandParameters";
import { ICommandResponse } from "../../authentication/connection/iCommandResponse";
import { CheckingAccountResponseDto, ErrorDetails, GridRequestDto } from "../../authentication/connection/interfaces/apiInterfaces";
import { IRequestCommand } from "../../authentication/connection/iRequestCommand";

export class GetCurrentAccountsCommand extends IRequestCommand<
  IGetCurrentAccountsResponse,
  ErrorDetails,
  IGetCurrentAccountsCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl =
    'carriers/{carrierUserId}/checkingAccounts/paginated?page={page}&size={size}&column={column}&sort={sort}';
  public override setParameters(parameters: IGetCurrentAccountsCommandParameters) {
    this._commandUrl = this._commandUrl.replace(
      '{carrierUserId}',
      parameters.carrierUserId.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{page}',
      parameters.page.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{size}',
      parameters.size.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{column}',
      parameters.column.toString()
    );
    this._commandUrl = this._commandUrl.replace(
      '{sort}',
      parameters.sort.toString()
    );
  }
}

export interface IGetCurrentAccountsCommandParameters
  extends ICommandParameters,
    GridRequestDto {}

export interface IGetCurrentAccountsResponse
  extends ICommandResponse,
    CheckingAccountResponseDto {}
